import React from 'react';

import { Skeleton } from '@sandtech-hub-monorepo/ui-kit';

export const LearningSkeleton = () => {
  return (
    <div className={'w-full h-fit rounded-lg'}>
      <div className="flex flex-col gap-4 w-full">
        <Skeleton className="w-full h-64 lg:h-32" />
        <Skeleton className="w-full h-64 lg:h-32" />
        <Skeleton className="w-full h-64 lg:h-32" />
      </div>
    </div>
  );
};
